import { motion } from "framer-motion";
import { Check, ShieldCheck } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { INSURERS, HEADWAY } from "../data/site";

export default function Rates() {
    return (
        <div data-testid="rates-page" className="pb-28">
            <PageHeader
                testid="rates-header"
                breadcrumb="Insurance & Rates"
                title="Clear numbers, kindly"
                number="05"
                label="Insurance & Rates"
                heading="Clear numbers, no surprises"
            >
                <div className="mt-12 grid gap-6 lg:grid-cols-2">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="rounded-3xl border border-amber-500/25 bg-[#281D17] p-9"
                    >
                        <p className="text-xs uppercase tracking-[0.25em] text-amber-400/80">
                            Self-pay session
                        </p>
                        <p className="mt-4 font-serif text-6xl text-amber-100">
                            $150
                        </p>
                        <p className="mt-5 text-sm leading-relaxed text-amber-100/65">
                            A flat, honest rate for a 50-minute session.
                            Superbills available if you'd like to seek
                            out-of-network reimbursement on your own.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.08 }}
                        className="rounded-3xl border border-amber-500/15 bg-[#1F1510]/50 p-9"
                    >
                        <h3 className="font-serif text-xl text-amber-100">
                            Using insurance?
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-amber-100/65">
                            We bill through Headway, which means you can see your
                            real cost before you ever book. Many clients pay only
                            their copay.
                        </p>
                        <ul className="mt-6 grid grid-cols-2 gap-2.5">
                            {INSURERS.map((ins) => (
                                <li
                                    key={ins}
                                    className="flex items-center gap-2 rounded-full border border-amber-500/15 bg-[#150e08] px-3.5 py-2 text-sm text-amber-100/75"
                                >
                                    <Check className="h-3.5 w-3.5 text-amber-400" />
                                    {ins}
                                </li>
                            ))}
                        </ul>
                        <a
                            href={HEADWAY}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-7 inline-flex items-center gap-2 rounded-full bg-amber-500 px-6 py-3 text-sm font-semibold text-[#1F1510] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-amber-400"
                        >
                            <ShieldCheck className="h-4 w-4" />
                            Check my benefits on Headway
                        </a>
                    </motion.div>
                </div>
            </PageHeader>
        </div>
    );
}
